import Index from './containers/Index';
import Overview from './containers/Overview';
import Call from './containers/Call';
import Debug from './containers/Debug';
// import Availability from './containers/Availability';
// import Support from './containers/Support';
import FollowUp from './containers/FollowUp';

// export const Info = {
//   _id: 'MODULE_REGICALL',
//   name: 'RegiCall',
//   path: 'regicall'
// };

export const Info = {
  _id: 'MODULE_REGICALL',
  name: 'Zilverlijn',
  path: 'zilverlijn'
};

export default {
  Info,
  routes: [{
    path: `/${Info.path}`,
    component: Index,
    children: [
    {
      ...Call.Info,
      component: Call
    },
    {
      ...Debug.Info,
      component: Debug
    },
    {
      ...FollowUp.Info,
      component: FollowUp
    }
    // {
    //   ...Availability.Info,
    //   component: Availability
    // },
    // {
    //   ...Support.Info,
    //   component: Support
    // }
    ]
  }]
};
